
import Vue from "vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";

export default Vue.extend({
  name: "shared-ride-serv-content",
  mixins: [UIFeatureMixin],
});
